import React from 'react';
import { observer, inject } from 'mobx-react';
import CollectionManager from '../common/CollectionManager';
import Form from './StandardOperationForm';
import Model from '../../models/StandardOperation';

export default inject('store')(observer(props => {
  return <CollectionManager
    collectionName='standardOperations'
    FormComponent={Form}
    getItems={props.store.getStandardOperations}
    getNewItem={() => Model.create()}
    {...props}
  />
}))


// WEBPACK FOOTER //
// ./src/components/standard-operations/StandardOperations.js